import React from "react";
import { NavNotice } from "@design-system/NavNotice/NavNotice";
import { useSideNavMode } from "@design-system/SideNav/SideNavProvider";
import { useNewVersionAvailable } from "./NewVersionAvailableContext";

/**
 * The compact new-version notice for an open side nav's footer, after the
 * help button. In the workspace nav it takes the billing chip's place while it
 * shows. A mini nav has no room for it; its help menu carries it instead.
 */
export const useInlineNewVersionNotice = () => {
    const { isNoticeVisible, refresh } = useNewVersionAvailable();
    const isMini = useSideNavMode() === "mini";

    return isNoticeVisible && !isMini ? (
        <NavNotice
            label="New version"
            hint="Refresh to update"
            onClick={refresh}
        />
    ) : null;
};
